import { print } from 'graphql';
import Vue from 'vue';
import api from './repository';
import GET_SIMULATIONS_QUERY from './queries/simulation/list';
import CREATE_SIMULATION_MUTATION from './queries/simulation/create';
import UPDATE_SIMULATION_MUTATION from './queries/simulation/update';
import SIMULATION_QUESTION_MUTATION from './queries/simulation/answer';
import SIMULATION_DETAILS_QUERY from './queries/simulation/details';
import PROFESSION_QUESTIONS_QUERY from './queries/simulation/questions';
import ACCEPT_SIMULATION_MUTATION from './queries/simulation/accept';
import PROCESS_SIMULATION_MUTATION from './queries/simulation/process';

export default {
  async getSimulations(contractNumber, language, page) {
    try {
      const response = await api.post('/graphql/', {
        query: print(GET_SIMULATIONS_QUERY),
        variables: {
          contractNumber,
          language,
          page,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async createSimulation(simulation, primaryContract) {
    try {
      const response = await api.post('/graphql/', {
        query: print(CREATE_SIMULATION_MUTATION),
        variables: {
          contractId: parseInt(primaryContract.contractId, 10),
          calculationTypeKeys: simulation.calculationTypeKeys,
          dateClosingFiscalYear: Vue.moment(simulation.dateClosingFiscalYear).format('YYYY-MM-DD'),
          maritalStateKey: simulation.maritalStateKey,
          salaries: simulation.salaries,
          commission: simulation.commission,
          language: simulation.language,
          calculationDate: process.env.VUE_APP_2021 === 'true' ? '2021-01-01' : null,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async getSimulationDetails(simulationId, language) {
    try {
      const response = await api.post('/graphql/', {
        query: print(SIMULATION_DETAILS_QUERY),
        variables: {
          simulationId,
          language,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async updateSimulation(simulationId, explanation) {
    try {
      const response = await api.post('/graphql/', {
        query: print(UPDATE_SIMULATION_MUTATION),
        variables: {
          simulationId,
          explanation,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async acceptSimulation(simulationId, calculationType, yearlypremium, backservice, comment) {
    try {
      const response = await api.post('/graphql/', {
        query: print(ACCEPT_SIMULATION_MUTATION),
        variables: {
          simulationId,
          calculationType,
          yearlypremium,
          backservice,
          comment,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async processSimulation(simulationId, calculationType) {
    try {
      const response = await api.post('/graphql/', {
        query: print(PROCESS_SIMULATION_MUTATION),
        variables: {
          simulationId,
          calculationType,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async getQuestions(professionKey) {
    try {
      const response = await api.post('/graphql/', {
        query: print(PROFESSION_QUESTIONS_QUERY),
        variables: {
          professionKey,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async getSimulationPdf(simulationId, language) {
    try {
      const response = await api.get(`/download/${simulationId}`, { responseType: 'blob', headers: { 'Accept-Language': `${language}` } });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async saveSimulationAnswers(answers, simulationId, professionId) {
    try {
      const response = await api.post('/graphql/', {
        query: print(SIMULATION_QUESTION_MUTATION),
        variables: {
          simulationId,
          professionId,
          questions: answers,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
};
